import { activeSeasonalEffect } from 'components/SeasonalEffect/seasonalEffectConfig';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { FC, ReactNode, useMemo } from 'react';

import { SidebarContext } from './SidebarContext';

export const SidebarContextProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useLocalStorage('sidebarCollapsed', false);
  const [isSeasonalEffectEnabled, setIsSeasonalEffectEnabled] = useLocalStorage(`seasonalEffectEnabled.${activeSeasonalEffect}`, true);

  const value = useMemo(
    () => ({ isCollapsed, setIsCollapsed, isSeasonalEffectEnabled, setIsSeasonalEffectEnabled }),
    [isCollapsed, setIsCollapsed, isSeasonalEffectEnabled, setIsSeasonalEffectEnabled],
  );

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
};
